// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { GetMeResponse, UpdateMeData, UpdateMeResponse, RegisterDeviceData, RegisterDeviceResponse, UnregisterDeviceResponse, GetPayoutsData, GetPayoutsResponse, GetProvidersData, GetProvidersResponse, GetProviderFilterCountData, GetProviderFilterCountResponse, GetProviderData, GetProviderResponse, GetProviderAvailabilityData, GetProviderAvailabilityResponse, GetAvailableFiltersResponse, GetOfferingsVariationConfigResponse, GetProviderMeResponse, UpdateProviderMeData, UpdateProviderMeResponse, GetMyProviderPersonalityResponse, UpdateMyProviderPersonalityData, UpdateMyProviderPersonalityResponse, GetProviderMeAvailabilityRulesResponse, UpdateProviderMeAvailabilityRulesData, UpdateProviderMeAvailabilityRulesResponse, UpdateProviderMeSettingsData, UpdateProviderMeSettingsResponse, UpdateProviderMeAvailabilitySettingsData, UpdateProviderMeAvailabilitySettingsResponse, GetMeOfferingsResponse, UpdateMeOfferingsData, UpdateMeOfferingsResponse, UpdateMeOfferingsByIdData, UpdateMeOfferingsByIdResponse, DeleteMeOfferingData, DeleteMeOfferingResponse, GetConditionsData, GetConditionsResponse, GetMethodsData, GetMethodsResponse, GetTitlesData, GetTitlesResponse, GetCarouselData, GetCarouselResponse, GetGuidedSearchResponse, GetCarousel1Data, GetCarousel1Response, GetOrganizationEligibleMethodsResponse, GetOrganizationMethodBudgetData, GetOrganizationMethodBudgetResponse, GetOrganizationFriskvardBudgetData, GetOrganizationFriskvardBudgetResponse, GetOrganizationMembershipResponse, GetOrganizationByIdResponse, UpdateOrganizationData, UpdateOrganizationResponse, GetOrganizationUsersResponse, GetOrganizationStatisticsResponse, GetOrganizationBookingStatisticsData, GetOrganizationBookingStatisticsResponse, RemoveUserData, RemoveUserResponse, SetUserDepartmentData, SetUserDepartmentResponse, InviteUsersData, InviteUsersResponse, SetUserBudgetOverrideData, SetUserBudgetOverrideResponse, GetFriskvardPaymentsResponse, GetMethodPackagesResponse, SetMethodPackageEnabledData, SetMethodPackageEnabledResponse, GetDepartmentsResponse, CreateDepartmentData, CreateDepartmentResponse, UpdateDepartmentData, UpdateDepartmentResponse, DeleteDepartmentData, DeleteDepartmentResponse, GetOrganizationCompetitionsResponse, CreateOrganizationCompetitionData, CreateOrganizationCompetitionResponse, UpdateOrganizationCompetitionData, UpdateOrganizationCompetitionResponse, DeleteOrganizationCompetitionData, DeleteOrganizationCompetitionResponse, GetOrganizationCompetitionLeaderboardData, GetOrganizationCompetitionLeaderboardResponse, GetCompetitionsResponse, GetCompetitionData, GetCompetitionResponse, EnterCompetitionData, EnterCompetitionResponse, CompleteCompetitionChallengeData, CompleteCompetitionChallengeResponse, GetCompetitionLeaderboardData, GetCompetitionLeaderboardResponse, PostV1BookingsStripeWebhookResponse, GetV1BookingsByBookingIdReceiptData, GetV1BookingsByBookingIdReceiptResponse, GetV1BookingsFriskvardReceiptByPaymentIdData, GetV1BookingsFriskvardReceiptByPaymentIdResponse, GetCallDetailsData, GetCallDetailsResponse, GetBookingsData, GetBookingsResponse, CreateBookingData, CreateBookingResponse, GetBookingData, GetBookingResponse, CancelBookingData, CancelBookingResponse, ReviewBookingData, ReviewBookingResponse, RecomputeMyOrganizationSpendResponse, UsePromosData, UsePromosResponse, FreeCheckoutData, FreeCheckoutResponse, GetUserGiftcardsResponse, ClaimGiftcardData, ClaimGiftcardResponse, ListConversationsResponse, CreateConversationData, CreateConversationResponse, ListMessagesData, ListMessagesResponse, SendMessageData, SendMessageResponse, AddReactionData, AddReactionResponse, RemoveReactionData, RemoveReactionResponse, DeleteMessageData, DeleteMessageResponse, SendAiChatMessageData, SendAiChatMessageResponse, GetAiThreadData, GetAiThreadResponse, DeleteAiThreadData, DeleteAiThreadResponse } from './types.gen';

export class UsersService {
    /**
     * @returns UserMe
     * @throws ApiError
     */
    public static getMe(): CancelablePromise<GetMeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/users/me',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.formData
     * @returns UserMe
     * @throws ApiError
     */
    public static updateMe(data: UpdateMeData): CancelablePromise<UpdateMeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/users/me',
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns string
     * @throws ApiError
     */
    public static registerDevice(data: RegisterDeviceData): CancelablePromise<RegisterDeviceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/users/me/devices',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @returns string
     * @throws ApiError
     */
    public static unregisterDevice(): CancelablePromise<UnregisterDeviceResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/users/me/devices',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
}

export class PayoutsService {
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.page
     * @returns PayoutPage
     * @throws ApiError
     */
    public static getPayouts(data: GetPayoutsData = {}): CancelablePromise<GetPayoutsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/me/payouts',
            query: {
                limit: data.limit,
                page: data.page
            }
        });
    }
    
}

export class ProvidersService {
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.page
     * @param data.spokenLanguages
     * @param data.methods
     * @param data.conditions
     * @param data.titles
     * @param data.genders
     * @param data.durations
     * @param data.friskvardEligible Only providers offering at least one friskvård-eligible method
     * @param data.paidByOrganization Only providers offering at least one method covered by the signed-in user's organization packages. Requires authentication; matches nothing for users without an organization.
     * @param data.search Typo tolerant, case and accent insensitive search on provider name. Results are ordered by relevance, then by sort.
     * @param data.sort
     * @param data.nextAvailableStart Can be provided without nextAvailableEnd
     * @param data.nextAvailableEnd Must have nextAvailableStart to take effect
     * @returns ProviderPage
     * @throws ApiError
     */
    public static getProviders(data: GetProvidersData = {}): CancelablePromise<GetProvidersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers',
            query: {
                limit: data.limit,
                page: data.page,
                spokenLanguages: data.spokenLanguages,
                methods: data.methods,
                conditions: data.conditions,
                titles: data.titles,
                genders: data.genders,
                durations: data.durations,
                friskvardEligible: data.friskvardEligible,
                paidByOrganization: data.paidByOrganization,
                search: data.search,
                sort: data.sort,
                nextAvailableStart: data.nextAvailableStart,
                nextAvailableEnd: data.nextAvailableEnd
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.page
     * @param data.spokenLanguages
     * @param data.methods
     * @param data.conditions
     * @param data.titles
     * @param data.genders
     * @param data.durations
     * @param data.friskvardEligible Only providers offering at least one friskvård-eligible method
     * @param data.paidByOrganization Only providers offering at least one method covered by the signed-in user's organization packages. Requires authentication; matches nothing for users without an organization.
     * @param data.search Typo tolerant, case and accent insensitive search on provider name. Results are ordered by relevance, then by sort.
     * @param data.sort
     * @param data.nextAvailableStart Can be provided without nextAvailableEnd
     * @param data.nextAvailableEnd Must have nextAvailableStart to take effect
     * @returns unknown
     * @throws ApiError
     */
    public static getProviderFilterCount(data: GetProviderFilterCountData = {}): CancelablePromise<GetProviderFilterCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/filter-count',
            query: {
                limit: data.limit,
                page: data.page,
                spokenLanguages: data.spokenLanguages,
                methods: data.methods,
                conditions: data.conditions,
                titles: data.titles,
                genders: data.genders,
                durations: data.durations,
                friskvardEligible: data.friskvardEligible,
                paidByOrganization: data.paidByOrganization,
                search: data.search,
                sort: data.sort,
                nextAvailableStart: data.nextAvailableStart,
                nextAvailableEnd: data.nextAvailableEnd
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @returns Provider
     * @throws ApiError
     */
    public static getProvider(data: GetProviderData): CancelablePromise<GetProviderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/{id}',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.duration
     * @returns ProviderAvailabilityTimeSlots
     * @throws ApiError
     */
    public static getProviderAvailability(data: GetProviderAvailabilityData): CancelablePromise<GetProviderAvailabilityResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/{id}/availability',
            path: {
                id: data.id
            },
            query: {
                duration: data.duration
            }
        });
    }
    
    /**
     * @returns ProviderAvailableFilters
     * @throws ApiError
     */
    public static getAvailableFilters(): CancelablePromise<GetAvailableFiltersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/available-filters'
        });
    }
    
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static getOfferingsVariationConfig(): CancelablePromise<GetOfferingsVariationConfigResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/offerings-variation-config'
        });
    }
    
    /**
     * @returns ProviderMe
     * @throws ApiError
     */
    public static getProviderMe(): CancelablePromise<GetProviderMeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/me'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.formData
     * @returns ProviderMe
     * @throws ApiError
     */
    public static updateProviderMe(data: UpdateProviderMeData): CancelablePromise<UpdateProviderMeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/providers/me',
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                404: 'Provider not found'
            }
        });
    }
    
    /**
     * Personality self-assessment of the signed-in provider. Never public.
     * @returns ProviderPersonality
     * @throws ApiError
     */
    public static getMyProviderPersonality(): CancelablePromise<GetMyProviderPersonalityResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/me/personality',
            errors: {
                404: 'Provider metadata not found'
            }
        });
    }
    
    /**
     * Replaces the whole personality (omitted fields are cleared). Saved directly, no review. completedAt is set when traits, all six scales and yearsOfExperience are present.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ProviderPersonality
     * @throws ApiError
     */
    public static updateMyProviderPersonality(data: UpdateMyProviderPersonalityData): CancelablePromise<UpdateMyProviderPersonalityResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/providers/me/personality',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: 'Provider metadata not found'
            }
        });
    }
    
    /**
     * @returns ProviderAvailabilityRules
     * @throws ApiError
     */
    public static getProviderMeAvailabilityRules(): CancelablePromise<GetProviderMeAvailabilityRulesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/me/availability-rules'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ProviderAvailabilityRules
     * @throws ApiError
     */
    public static updateProviderMeAvailabilityRules(data: UpdateProviderMeAvailabilityRulesData): CancelablePromise<UpdateProviderMeAvailabilityRulesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/providers/me/availability-rules',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ProviderSettings
     * @throws ApiError
     */
    public static updateProviderMeSettings(data: UpdateProviderMeSettingsData): CancelablePromise<UpdateProviderMeSettingsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/providers/me/settings',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ProviderAvailabliltySettings
     * @throws ApiError
     */
    public static updateProviderMeAvailabilitySettings(data: UpdateProviderMeAvailabilitySettingsData): CancelablePromise<UpdateProviderMeAvailabilitySettingsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/providers/me/availability-settings',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns ProviderOfferingList
     * @throws ApiError
     */
    public static getMeOfferings(): CancelablePromise<GetMeOfferingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/me/offerings'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ProviderOfferingList
     * @throws ApiError
     */
    public static updateMeOfferings(data: UpdateMeOfferingsData): CancelablePromise<UpdateMeOfferingsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/providers/me/offerings',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.offeringMethodId
     * @param data.requestBody
     * @returns ProviderOfferingList
     * @throws ApiError
     */
    public static updateMeOfferingsById(data: UpdateMeOfferingsByIdData): CancelablePromise<UpdateMeOfferingsByIdResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/providers/me/offerings/{offeringMethodId}',
            path: {
                offeringMethodId: data.offeringMethodId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.offeringMethodId
     * @returns ProviderOfferingList
     * @throws ApiError
     */
    public static deleteMeOffering(data: DeleteMeOfferingData): CancelablePromise<DeleteMeOfferingResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/providers/me/offerings/{offeringMethodId}',
            path: {
                offeringMethodId: data.offeringMethodId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.page
     * @returns ConditionPage
     * @throws ApiError
     */
    public static getConditions(data: GetConditionsData = {}): CancelablePromise<GetConditionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/conditions',
            query: {
                limit: data.limit,
                page: data.page
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.page
     * @param data.type
     * @returns MethodsPage
     * @throws ApiError
     */
    public static getMethods(data: GetMethodsData = {}): CancelablePromise<GetMethodsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/methods',
            query: {
                limit: data.limit,
                page: data.page,
                type: data.type
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.page
     * @returns TitlePage
     * @throws ApiError
     */
    public static getTitles(data: GetTitlesData = {}): CancelablePromise<GetTitlesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/providers/titles',
            query: {
                limit: data.limit,
                page: data.page
            }
        });
    }
    
}

export class AppService {
    /**
     * @param data The data for the request.
     * @param data.itemName
     * @returns Carousel
     * @throws ApiError
     */
    public static getCarousel(data: GetCarouselData): CancelablePromise<GetCarouselResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/carousels/{itemName}',
            path: {
                itemName: data.itemName
            },
            errors: {
                404: ''
            }
        });
    }
    
    /**
     * @returns GuidedSearch
     * @throws ApiError
     */
    public static getGuidedSearch(): CancelablePromise<GetGuidedSearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/app/guided-search',
            errors: {
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.itemName
     * @returns Carousel
     * @throws ApiError
     */
    public static getCarousel1(data: GetCarousel1Data): CancelablePromise<GetCarousel1Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/app/carousel/{itemName}',
            path: {
                itemName: data.itemName
            },
            errors: {
                404: ''
            }
        });
    }
    
}

export class OrganizationsService {
    /**
     * @returns OrganizationEligibleMethods
     * @throws ApiError
     */
    public static getOrganizationEligibleMethods(): CancelablePromise<GetOrganizationEligibleMethodsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/eligible-methods',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.methodId
     * @returns OrganizationMethodBudget
     * @throws ApiError
     */
    public static getOrganizationMethodBudget(data: GetOrganizationMethodBudgetData): CancelablePromise<GetOrganizationMethodBudgetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/method-budget/{methodId}',
            path: {
                methodId: data.methodId
            },
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.methodId
     * @returns OrganizationFriskvardBudget
     * @throws ApiError
     */
    public static getOrganizationFriskvardBudget(data: GetOrganizationFriskvardBudgetData): CancelablePromise<GetOrganizationFriskvardBudgetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/friskvard-budget/{methodId}',
            path: {
                methodId: data.methodId
            },
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @returns OrganizationMembership
     * @throws ApiError
     */
    public static getOrganizationMembership(): CancelablePromise<GetOrganizationMembershipResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/membership',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @returns OrganizationGet
     * @throws ApiError
     */
    public static getOrganizationById(): CancelablePromise<GetOrganizationByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns OrganizationGet
     * @throws ApiError
     */
    public static updateOrganization(data: UpdateOrganizationData): CancelablePromise<UpdateOrganizationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/organizations',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @returns OrganizationUsers
     * @throws ApiError
     */
    public static getOrganizationUsers(): CancelablePromise<GetOrganizationUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/users',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @returns OrganizationStatistics
     * @throws ApiError
     */
    public static getOrganizationStatistics(): CancelablePromise<GetOrganizationStatisticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/statistics',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.startDate
     * @param data.endDate
     * @param data.departmentId
     * @param data.bookingType
     * @returns OrganizationBookingStatistics
     * @throws ApiError
     */
    public static getOrganizationBookingStatistics(data: GetOrganizationBookingStatisticsData = {}): CancelablePromise<GetOrganizationBookingStatisticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/statistics/bookings',
            query: {
                startDate: data.startDate,
                endDate: data.endDate,
                departmentId: data.departmentId,
                bookingType: data.bookingType
            },
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.userId
     * @returns unknown
     * @throws ApiError
     */
    public static removeUser(data: RemoveUserData): CancelablePromise<RemoveUserResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/organizations/users/{userId}',
            path: {
                userId: data.userId
            },
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.userId
     * @param data.requestBody
     * @returns OrganizationUsers
     * @throws ApiError
     */
    public static setUserDepartment(data: SetUserDepartmentData): CancelablePromise<SetUserDepartmentResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/organizations/users/{userId}',
            path: {
                userId: data.userId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static inviteUsers(data: InviteUsersData): CancelablePromise<InviteUsersResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/organizations/invite-users',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.userId
     * @param data.requestBody
     * @returns OrganizationUsers
     * @throws ApiError
     */
    public static setUserBudgetOverride(data: SetUserBudgetOverrideData): CancelablePromise<SetUserBudgetOverrideResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/organizations/users/{userId}/budget',
            path: {
                userId: data.userId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @returns FriskvardPayments
     * @throws ApiError
     */
    public static getFriskvardPayments(): CancelablePromise<GetFriskvardPaymentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/friskvard-payments',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @returns OrganizationMethodPackages
     * @throws ApiError
     */
    public static getMethodPackages(): CancelablePromise<GetMethodPackagesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/method-packages',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.packageId
     * @param data.requestBody
     * @returns OrganizationMethodPackages
     * @throws ApiError
     */
    public static setMethodPackageEnabled(data: SetMethodPackageEnabledData): CancelablePromise<SetMethodPackageEnabledResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/organizations/method-packages/{packageId}',
            path: {
                packageId: data.packageId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @returns OrganizationDepartments
     * @throws ApiError
     */
    public static getDepartments(): CancelablePromise<GetDepartmentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/departments',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns OrganizationDepartment
     * @throws ApiError
     */
    public static createDepartment(data: CreateDepartmentData): CancelablePromise<CreateDepartmentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/organizations/departments',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.departmentId
     * @param data.requestBody
     * @returns OrganizationDepartment
     * @throws ApiError
     */
    public static updateDepartment(data: UpdateDepartmentData): CancelablePromise<UpdateDepartmentResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/organizations/departments/{departmentId}',
            path: {
                departmentId: data.departmentId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.departmentId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteDepartment(data: DeleteDepartmentData): CancelablePromise<DeleteDepartmentResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/organizations/departments/{departmentId}',
            path: {
                departmentId: data.departmentId
            },
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
}

export class CompetitionsService {
    /**
     * @returns OrganizationCompetitions
     * @throws ApiError
     */
    public static getOrganizationCompetitions(): CancelablePromise<GetOrganizationCompetitionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/competitions',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns OrganizationCompetition
     * @throws ApiError
     */
    public static createOrganizationCompetition(data: CreateOrganizationCompetitionData): CancelablePromise<CreateOrganizationCompetitionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/organizations/competitions',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.competitionId
     * @param data.requestBody
     * @returns OrganizationCompetition
     * @throws ApiError
     */
    public static updateOrganizationCompetition(data: UpdateOrganizationCompetitionData): CancelablePromise<UpdateOrganizationCompetitionResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/organizations/competitions/{competitionId}',
            path: {
                competitionId: data.competitionId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.competitionId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteOrganizationCompetition(data: DeleteOrganizationCompetitionData): CancelablePromise<DeleteOrganizationCompetitionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/organizations/competitions/{competitionId}',
            path: {
                competitionId: data.competitionId
            },
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.competitionId
     * @returns CompetitionLeaderboard
     * @throws ApiError
     */
    public static getOrganizationCompetitionLeaderboard(data: GetOrganizationCompetitionLeaderboardData): CancelablePromise<GetOrganizationCompetitionLeaderboardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/organizations/competitions/{competitionId}/leaderboard',
            path: {
                competitionId: data.competitionId
            },
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @returns Competitions
     * @throws ApiError
     */
    public static getCompetitions(): CancelablePromise<GetCompetitionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/competitions',
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.competitionId
     * @returns Competition
     * @throws ApiError
     */
    public static getCompetition(data: GetCompetitionData): CancelablePromise<GetCompetitionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/competitions/{competitionId}',
            path: {
                competitionId: data.competitionId
            },
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.competitionId
     * @returns Competition
     * @throws ApiError
     */
    public static enterCompetition(data: EnterCompetitionData): CancelablePromise<EnterCompetitionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/competitions/{competitionId}/enter',
            path: {
                competitionId: data.competitionId
            },
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.competitionId
     * @param data.challengeId
     * @returns Competition
     * @throws ApiError
     */
    public static completeCompetitionChallenge(data: CompleteCompetitionChallengeData): CancelablePromise<CompleteCompetitionChallengeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/competitions/{competitionId}/challenges/{challengeId}/complete',
            path: {
                competitionId: data.competitionId,
                challengeId: data.challengeId
            },
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.competitionId
     * @returns CompetitionLeaderboard
     * @throws ApiError
     */
    public static getCompetitionLeaderboard(data: GetCompetitionLeaderboardData): CancelablePromise<GetCompetitionLeaderboardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/competitions/{competitionId}/leaderboard',
            path: {
                competitionId: data.competitionId
            },
            errors: {
                401: 'Unauthorized'
            }
        });
    }
    
}

export class BookingsService {
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static postV1BookingsStripeWebhook(): CancelablePromise<PostV1BookingsStripeWebhookResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bookings/stripe/webhook'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.bookingId
     * @returns unknown
     * @throws ApiError
     */
    public static getV1BookingsByBookingIdReceipt(data: GetV1BookingsByBookingIdReceiptData): CancelablePromise<GetV1BookingsByBookingIdReceiptResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/bookings/{bookingId}/receipt',
            path: {
                bookingId: data.bookingId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.paymentId
     * @returns unknown
     * @throws ApiError
     */
    public static getV1BookingsFriskvardReceiptByPaymentId(data: GetV1BookingsFriskvardReceiptByPaymentIdData): CancelablePromise<GetV1BookingsFriskvardReceiptByPaymentIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/bookings/friskvard-receipt/{paymentId}',
            path: {
                paymentId: data.paymentId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.bookingId
     * @param data.uid
     * @returns BookingCall
     * @throws ApiError
     */
    public static getCallDetails(data: GetCallDetailsData): CancelablePromise<GetCallDetailsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/bookings/{bookingId}/call',
            path: {
                bookingId: data.bookingId
            },
            query: {
                uid: data.uid
            },
            errors: {
                401: '',
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.limit
     * @param data.page
     * @returns BookingPage
     * @throws ApiError
     */
    public static getBookings(data: GetBookingsData = {}): CancelablePromise<GetBookingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/bookings',
            query: {
                limit: data.limit,
                page: data.page
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns BookingCreated
     * @throws ApiError
     */
    public static createBooking(data: CreateBookingData): CancelablePromise<CreateBookingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bookings',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: '',
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.bookingId
     * @returns Booking
     * @throws ApiError
     */
    public static getBooking(data: GetBookingData): CancelablePromise<GetBookingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/bookings/{bookingId}',
            path: {
                bookingId: data.bookingId
            },
            errors: {
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.bookingId
     * @returns Booking
     * @throws ApiError
     */
    public static cancelBooking(data: CancelBookingData): CancelablePromise<CancelBookingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bookings/{bookingId}/cancel',
            path: {
                bookingId: data.bookingId
            },
            errors: {
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.bookingId
     * @param data.requestBody
     * @returns Booking
     * @throws ApiError
     */
    public static reviewBooking(data: ReviewBookingData): CancelablePromise<ReviewBookingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bookings/{bookingId}/review',
            path: {
                bookingId: data.bookingId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: ''
            }
        });
    }
    
    /**
     * @returns RecomputeOrganizationSpend
     * @throws ApiError
     */
    public static recomputeMyOrganizationSpend(): CancelablePromise<RecomputeMyOrganizationSpendResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bookings/recompute-organization-spend'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.bookingId
     * @param data.requestBody
     * @returns Booking
     * @throws ApiError
     */
    public static usePromos(data: UsePromosData): CancelablePromise<UsePromosResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bookings/{bookingId}/promos',
            path: {
                bookingId: data.bookingId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.bookingId
     * @returns Booking
     * @throws ApiError
     */
    public static freeCheckout(data: FreeCheckoutData): CancelablePromise<FreeCheckoutResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bookings/{bookingId}/checkout',
            path: {
                bookingId: data.bookingId
            },
            errors: {
                404: ''
            }
        });
    }
    
}

export class GiftcardsService {
    /**
     * @returns GiftcardList
     * @throws ApiError
     */
    public static getUserGiftcards(): CancelablePromise<GetUserGiftcardsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/giftcards',
            errors: {
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.code
     * @returns unknown
     * @throws ApiError
     */
    public static claimGiftcard(data: ClaimGiftcardData): CancelablePromise<ClaimGiftcardResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/giftcards/claim',
            query: {
                code: data.code
            },
            errors: {
                404: ''
            }
        });
    }
    
}

export class MessagingService {
    /**
     * @returns Conversations
     * @throws ApiError
     */
    public static listConversations(): CancelablePromise<ListConversationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/messaging'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Conversation
     * @throws ApiError
     */
    public static createConversation(data: CreateConversationData): CancelablePromise<CreateConversationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/messaging',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.conversationId
     * @param data.limit
     * @param data.cursor createdAt of the oldest message in the previous batch
     * @returns MessageCursorPage
     * @throws ApiError
     */
    public static listMessages(data: ListMessagesData): CancelablePromise<ListMessagesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/messaging/{conversationId}',
            path: {
                conversationId: data.conversationId
            },
            query: {
                limit: data.limit,
                cursor: data.cursor
            },
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.conversationId
     * @param data.requestBody
     * @returns Message
     * @throws ApiError
     */
    public static sendMessage(data: SendMessageData): CancelablePromise<SendMessageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/messaging/{conversationId}',
            path: {
                conversationId: data.conversationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.conversationId
     * @param data.messageId
     * @param data.requestBody
     * @returns Message
     * @throws ApiError
     */
    public static addReaction(data: AddReactionData): CancelablePromise<AddReactionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/messaging/{conversationId}/messages/{messageId}/reactions',
            path: {
                conversationId: data.conversationId,
                messageId: data.messageId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.conversationId
     * @param data.messageId
     * @param data.emoji
     * @returns Message
     * @throws ApiError
     */
    public static removeReaction(data: RemoveReactionData): CancelablePromise<RemoveReactionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/messaging/{conversationId}/messages/{messageId}/reactions/{emoji}',
            path: {
                conversationId: data.conversationId,
                messageId: data.messageId,
                emoji: data.emoji
            },
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.conversationId
     * @param data.messageId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteMessage(data: DeleteMessageData): CancelablePromise<DeleteMessageResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/messaging/{conversationId}/messages/{messageId}',
            path: {
                conversationId: data.conversationId,
                messageId: data.messageId
            },
            errors: {
                403: '',
                404: ''
            }
        });
    }
    
}

export class AiChatService {
    /**
     * Streams an AI SDK UI message stream (SSE, `text/event-stream`). Call with fetch / `DefaultChatTransport`, not the generated client. Custom parts: `data-thread` { threadId } when a new thread is created, `data-suggestions` { providers, methods, strictMatch, reason? }. Returns 429 (with Retry-After) when rate limited and 404 when the thread does not belong to the caller.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static sendAiChatMessage(data: SendAiChatMessageData): CancelablePromise<SendAiChatMessageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/ai-chat',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.threadId
     * @returns AiThread
     * @throws ApiError
     */
    public static getAiThread(data: GetAiThreadData): CancelablePromise<GetAiThreadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/ai-chat/{threadId}',
            path: {
                threadId: data.threadId
            },
            errors: {
                404: ''
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.threadId
     * @returns unknown
     * @throws ApiError
     */
    public static deleteAiThread(data: DeleteAiThreadData): CancelablePromise<DeleteAiThreadResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/ai-chat/{threadId}',
            path: {
                threadId: data.threadId
            },
            errors: {
                404: ''
            }
        });
    }
    
}